import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6a38bdf8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6a38bdf8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a38bdf8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a38bdf8')) {
      api.createRecord('6a38bdf8', component.options)
    } else {
      api.reload('6a38bdf8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6a38bdf8&scoped=true", function () {
      api.rerender('6a38bdf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/password/index.vue"
export default component.exports